export function createFrameLoop(
  frame: () => void,
  requestFrame: (callback: FrameRequestCallback) => number = requestAnimationFrame,
  reportError: (error: unknown) => void = (error) => console.error("[frame] render failed", error),
): () => void {
  const tick: FrameRequestCallback = () => {
    try {
      frame();
    } catch (error) {
      reportError(error);
    } finally {
      requestFrame(tick);
    }
  };
  return () => { requestFrame(tick); };
}
